import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import _ from 'lodash';

import { RootState } from '/store';

export interface IPageTitleState {
  currentEntityName: string | undefined;
}

const initialState: IPageTitleState = {
  currentEntityName: undefined,
};

const pageTitleSlice = createSlice({
  name: 'pageTitle',
  initialState,
  reducers: {
    setCurrentEntityName: (state, action: PayloadAction<string | undefined>) => {
      state.currentEntityName = action.payload;
    },
    rehydrate: (state) => {
      _.merge(state, initialState);
    },
  },
});

export const pageTitleToolkit = Object.freeze({
  initialState,
  actions: pageTitleSlice.actions,
  selectors: {
    state: (state: RootState) => state.pageTitle,
    rehydrate: (state: RootState) => state.pageTitle,
    currentEntityName: (state: RootState) => state.pageTitle.currentEntityName,
  },
});

export const pageTitleReducer = pageTitleSlice.reducer;
